import { render, staticRenderFns } from "./policyreport.vue?vue&type=template&id=1d1315aa&scoped=true&"
import script from "./policyreport.vue?vue&type=script&lang=js&"
export * from "./policyreport.vue?vue&type=script&lang=js&"
import style0 from "./policyreport.vue?vue&type=style&index=0&id=1d1315aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1315aa",
  null
  
)

export default component.exports